export default __webpack_public_path__ + "static/media/step3.e9ab2819.svg";